import Cookies from 'js-cookie';
import domReady from '../helpers/dom-ready';

class Popup {
  static init() {
    return new Popup();
  }

  constructor() {
    this.popup = document.querySelector('.popup-wrapper');
    this.menu = document.querySelector('.brix-menu');

    if (this.popup) {
      this.openPopup();
      this.setUpPopup();
    }
  }

  setUpPopup() {
    this.menu.classList.add('-behind-popup');
    const closeButton = this.popup.querySelector('.close-button');
    const background = this.popup.querySelector('.transparent-background');
    this.button = this.popup.querySelector('.button');

    closeButton.addEventListener('click', () => {
      this.closePopup();
    });
    background.addEventListener('click', () => {
      this.closePopup();
    });

    if (this.button) {
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.closePopup(true);
      });
    }
  }

  openPopup() {
    this.disableBodyScroll();
  }

  closePopup(isButtonClick = false) {
    const { activationDate } = this.popup.dataset;
    const cookie = Cookies.get(`brix-popup-${activationDate}`);

    if (!cookie) {
      Cookies.set(`brix-popup-${activationDate}`, true, {
        expires: 365,
      });
    }

    if (isButtonClick) {
      const target = this.button.target || '_self';
      window.open(this.button.href, target);
    } else {
      this.popup.classList.add('-hidden');
      this.menu.classList.remove('-behind-popup');

      this.enableBodyScroll();
    }
  }

  enableBodyScroll() {
    document.body.classList.remove('-scroll-lock');
  }

  disableBodyScroll() {
    document.body.classList.add('-scroll-lock');
  }
}

domReady(() => {
  Popup.init();
});
